var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticStyle:{"height":"100%"}},[(!_vm.isHomeworksLoading)?_c('homework-list'):_c('circular-progress')],1)}
var staticRenderFns = []

export { render, staticRenderFns }